import React from "react";

export const RECON_STATUS = {
  confirmed: { label: "Confirmed", tone: "gl-status-confirmed" },
  likely: { label: "Likely", tone: "gl-status-likely" },
  needs_review: { label: "Needs review", tone: "gl-status-review" },
  rejected: { label: "Rejected", tone: "gl-status-rejected" },
  unmatched: { label: "Unmatched", tone: "gl-status-unmatched" },
  suggested: { label: "Suggested", tone: "gl-status-suggested" },
};

export const MATCH_LABELS = {
  exact: "Exact",
  delayed: "Delayed",
  partial: "Split payment",
  combined: "Combined",
  currency: "Currency",
  ambiguous: "Ambiguous",
  unmatched: "Unmatched",
};

export const STATUS_CHIPS = [
  { key: "", label: "All" },
  { key: "confirmed", label: "Confirmed" },
  { key: "likely", label: "Likely" },
  { key: "needs_review", label: "Needs review" },
  { key: "rejected", label: "Rejected" },
  { key: "unmatched", label: "Unmatched" },
  { key: "suggested", label: "Suggested" },
];

export const incomeTypeLabel = (type, provider) => {
  if (type === "artists_revenue") {
    return String(provider || "").toLowerCase() === "youtube" ? "YouTube pooled" : "Artist revenue";
  }
  return type === "streaming" ? "Streaming" : type || "Income";
};

export const confidenceTone = (score) => {
  const value = Number(score) || 0;
  if (value >= 80) return "gl-confidence-high";
  if (value >= 65) return "gl-confidence-mid";
  if (value >= 45) return "gl-confidence-low";
  return "gl-confidence-none";
};

export function ConfidenceBadge({ score }) {
  const value = Number(score) || 0;
  return (
    <span className={`gl-confidence ${confidenceTone(value)}`} title="Confidence score">
      {value}%
    </span>
  );
}

export function ReconStatusBadge({ status, matchType }) {
  const meta = RECON_STATUS[status] || RECON_STATUS.unmatched;
  return (
    <span className="gl-recon-badges">
      <span className={`gl-recon-status ${meta.tone}`}>{meta.label}</span>
      {matchType && <span className="gl-recon-match">{MATCH_LABELS[matchType] || matchType}</span>}
    </span>
  );
}
